import * as React from 'react';
import ConsoleLayout from './ConsoleLayout';

class ReportsLayout extends React.Component<any, any> {
    public render() {
        return (
            <ConsoleLayout>
                {this.props.children}
            </ConsoleLayout>
        );
    }
}

export default ReportsLayout;
